import Vuex, { GetterTree } from 'vuex';
import { CourseState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<CourseState, RootState> = {
  selectedCourse: (state, getters) => {
    return state.course;
  },
  availableCourses: (state, getters) => {
    return state.availableCourses;
  },
  selectedModality: state => state.modality,
  // Só oferece a escolha de modalidade quando existe ao menos um curso SEMI; enquanto a
  // lista estiver vazia o fluxo é idêntico ao anterior à modalidade.
  hasSemiCourses: state =>
    (state.availableCourses || []).some(({ modality }) => modality === 'SEMI'),
};

export default getters;
